import { render } from "./Contract.vue?vue&type=template&id=ac073f44"
import script from "./Contract.vue?vue&type=script&lang=ts"
export * from "./Contract.vue?vue&type=script&lang=ts"
script.render = render

export default script